// extracted by mini-css-extract-plugin
module.exports = {"root":"nfDDwnXq","header":"Woa40l12","description":"apVaRRtS"};